import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = ({ t }) => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">
          <p className="footer-copyright">{t.footer.copyright}</p>
          <p className="footer-registration">{t.footer.registration}</p>
        </div>
        <div className="footer-center">
          <Link to="/privacy" className="footer-link">{t.footer.links.privacy}</Link>
          <span className="footer-divider">|</span>
          <Link to="/terms" className="footer-link">{t.footer.links.terms}</Link>
        </div>
        <div className="footer-right">
          <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Twitter">
            𝕏
          </a>
          <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="LinkedIn">
            in
          </a>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
            📷
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
